"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createControllerContextHocs = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const setDisplayName_1 = (0, tslib_1.__importDefault)(require("./setDisplayName"));
const getDisplayname_1 = require("./getDisplayname");
function createControllerContextHocs(Provider, Consumer) {
    const withProvider = () => (WrappedComponent) => {
        const WithProvider = (props) => ((0, jsx_runtime_1.jsx)(Provider, { children: (0, jsx_runtime_1.jsx)(WrappedComponent, Object.assign({}, props), void 0) }, void 0));
        return (0, setDisplayName_1.default)(`withControllerProvider(${(0, getDisplayname_1.getDisplayName)(Provider)})`)(WithProvider);
    };
    function withConsumer(mapProps) {
        return (WrappedComponent) => {
            const WithConsumer = (props) => ((0, jsx_runtime_1.jsx)(Consumer, { children: (value) => {
                    const mappedProps = mapProps(value.state, value.controller, value.props);
                    return (0, jsx_runtime_1.jsx)(WrappedComponent, Object.assign({}, props, mappedProps), void 0);
                } }, void 0));
            return (0, setDisplayName_1.default)(`withControllerConsumer(${(0, getDisplayname_1.getDisplayName)(Consumer)})`)(WithConsumer);
        };
    }
    return {
        withProvider,
        withConsumer,
    };
}
exports.createControllerContextHocs = createControllerContextHocs;
//# sourceMappingURL=createControllerContextHocs.js.map